<template>
    <v-layout column align-center class="text-center">
        <title-rounded title="당첨 상품">
            <v-sheet max-width="1100" class="text-center brown--text">
                <v-row justify="center" class="ma-lg-n24px">
                    <v-col v-for="item in reward" :key="item.title" cols="6" md="auto" class="pa-lg-24px" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="item.aosDelay">
                        <div class="hunt-reward word-keep-all">                            
                            <v-img :src="item.image" max-width="100%" :width="item.imageWidth" eager class="d-none d-md-block mx-auto mb-10px" />      
                            <v-img :src="item.imageMo" width="100%" max-width="166" eager class="d-md-none mx-auto mb-10px" />      
                            <h5 class="font-size-16 font-size-md-32">
                                {{item.title}}<span v-if="item.count" class="font-weight-regular"> ({{item.count}}명)</span>
                            </h5>
                            <p v-if="item.detail" class="font-size-14 font-size-md-28 mt-10px">
                                {{item.detail}}
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-sheet>
        </title-rounded>
    </v-layout>
</template>

<script>
import TitleRounded from "@/components/client/event/hunt/title-rounded.vue";

export default {
    components: {
        TitleRounded,
    },
    data() {
        return {
            reward: [
                {
                    title: "아이패드 에어 5세대",
                    count: "1",
                    detail: "64GB WIFI 색상 랜덤 발송",
                    image: "/images/event/hunt/reward-img.png",
                    imageMo: "/images/event/hunt/reward-img-mo.png",
                    imageWidth: "274",
                    aosDelay: "50",
                },
                {
                    title: "네스프레소 커피머신",
                    count: "3",
                    detail: "VERTUO POP 색상 랜덤 발송",
                    image: "/images/event/hunt/reward-img2.png",
                    imageMo: "/images/event/hunt/reward-img2-mo.png",
                    imageWidth: "206",
                    aosDelay: "100",
                },
                {
                    title: "나누리 상품권 3만원",
                    count: "20",
                    image: "/images/event/hunt/reward-img3.png",
                    imageMo: "/images/event/hunt/reward-img3-mo.png",
                    imageWidth: "276",
                    aosDelay: "100",
                },
                {
                    title: "CU 상품권 1만원",
                    count: "30",
                    image: "/images/event/hunt/reward-img4.png",
                    imageMo: "/images/event/hunt/reward-img4-mo.png",
                    imageWidth: "234",
                    aosDelay: "150",
                },
                {
                    title: "나누리 캐시 500원",
                    image: "/images/event/hunt/reward-img5.png",
                    imageMo: "/images/event/hunt/reward-img5-mo.png",
                    imageWidth: "180",
                    aosDelay: "200",
                },
            ],
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";
</style>